import { useIntl } from 'react-intl'

/**
 * Returns a lookup of CruiseDurationOptions.value -> localised label.
 * Shared between CruiseWhenSelectHowLong and CruiseSearchFiltersMobile.
 *
 * `intl.formatMessage` already caches by descriptor id, so no extra
 * memoisation is needed here.
 */
function useCruiseDurationLabels(): Record<string, string> {
  const intl = useIntl()

  return {
    'Any duration': intl.formatMessage({
      id: '1-V-v57Py1xxPhhXcw9p',
      defaultMessage: 'Any duration',
      description: 'Filter chip label for selecting any cruise duration',
    }),
    '1 - 7 Nights': intl.formatMessage({
      id: 'gP57FALJPyI5Se0XYK_v',
      defaultMessage: '1 - 7 Nights',
      description: 'Filter chip label for short cruise stays of 1 to 7 nights',
    }),
    '8 - 14 Nights': intl.formatMessage({
      id: 'uHftbHThb7VP03HiRdiN',
      defaultMessage: '8 - 14 Nights',
      description: 'Filter chip label for medium cruise stays of 8 to 14 nights',
    }),
    '15+ Nights': intl.formatMessage({
      id: 'GXcT7MDx62IcY3oLmjfM',
      defaultMessage: '15+ Nights',
      description: 'Filter chip label for long cruise stays of 15 or more nights',
    }),
  }
}

export default useCruiseDurationLabels
